import { RAISE_API_V1_URL } from "constants/endpoints";
import { get } from "services/api";

export const getShop = async ({ name }) => {
  const baseUrl = RAISE_API_V1_URL;
  const response = await get(`${baseUrl}/shop/${name}`);

  return response.data;
};
